import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import spartaGlobal from "utilities/global/sparta-global-utility/5.0.2/js/sparta-global-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.7/js/sparta-ui-layers-utility";
import Utility from "utilities/community/module-utils-utility/3.0.1/js/module-utils-utility";
import spartaTemplates from "modules/community/es-en-interstitial/3.1.0/js/templates";
import "css!modules/community/es-en-interstitial/3.1.0/css/es-en-interstitial.scss.css";


/*
 * tab-nav-module
 * module_js_id: esEnInterstitial
 *
 * Copyright (c) 2016-6-27 me
 */


export default class esEnInterstitial extends Module {
  constructor(options) {
    super(options);
    this.$target = $('#esEnInterstitial');
    this.bindAllMethod = Utility.bindAllMethod.bind(this);
    this.bindAllMethod();

    // exceptions
    this.exceptions = [{ type: 'id', value: 'english-route-to' },
      { type: 'class', value: 'no-interstitial' },
    ];
  }

  bypassException(e) {
    const $cache = e;
    const { exceptions } = this;

    for (const i in exceptions) {
      const attr = $cache.attr(exceptions[i].type) || '';
      const arrAttr = attr.split(/\s+/g);
      // if exception matches then return true
      if (arrAttr.includes(exceptions[i].value)) {
        return true;
      }
    }

    return false;
  }


  init(args = {}) {
    const self = this;

    const spanish = window.location.pathname.includes('/es/');

    // is page Spanish? (check LANG)
    if (spanish) {
      // wait a few seconds in case there is other js on the page that alters links
      setTimeout(() => {
        const $englishLinks = $("a:not([href$='/es/']), a:not([href$='/es'])");

        $englishLinks.each(function () {
          const $el = $(this);

          // if exception then continue
          if (self.bypassException($el)) {
            return true;
          }

          const href = $el.attr('href') || '';

          // do a double check to ensure we're not a spanish link
          if (!(/(\/es|locale=es_)/.test(href))) {
            // href needs to look like link or be a link
            if (/^\/[A-z0-9-]+/.test(href) || href.includes('http') || href.includes('www.')) {
              // only add if something isn't already declared
              if (!($el.attr('data-options') && $el.attr('data-options').indexOf('interstitialType') !== -1)) {
                $el.addClass('spa-ui-layer-link spa-fn')
                  .attr('data-options', '{"interstitialType": "language-change", "interstitialBranding": "default"}');
              }
            }
          }
        });
      }, 2000);
    }
  }
}
